"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const atoms_1 = require("@components/atoms");
const _theme_1 = require("@theme");
const _utils_1 = require("@utils"); // Component
var ImageAndCopyGrid = function ImageAndCopyGrid(_ref) {
    var items = _ref.items, title = _ref.title;
    return /*#__PURE__*/ react_1.default.createElement(Wrapper, null, /*#__PURE__*/ react_1.default.createElement(StyledSectionHeader, {
        small: true,
        title: title
    }), /*#__PURE__*/ react_1.default.createElement(Grid, null, items === null || items === void 0 ? void 0 : items.map(function (item, i) {
        return /*#__PURE__*/ react_1.default.createElement(Item, {
            key: i
        }, item.image && /*#__PURE__*/ react_1.default.createElement(ImageWrapper, null, /*#__PURE__*/ react_1.default.createElement(StyledImage, {
            src: item.image,
            frame: item.frame,
            widthClass: "tricolumn"
        }), /*#__PURE__*/ react_1.default.createElement(BoxShadow, {
            frame: item.frame
        })), /*#__PURE__*/ react_1.default.createElement(Copy, null, /*#__PURE__*/ react_1.default.createElement(Title, null, item.title), item.caption && /*#__PURE__*/ react_1.default.createElement(Caption, {
            dangerouslySetInnerHTML: {
                __html: item.caption
            }
        })));
    })));
}; // Styling
var Wrapper = styled_components_1.default.div.withConfig({
    displayName: "ImageAndCopyGrid__Wrapper",
    componentId: "sc-1us59xh-0"
})(["position:relative;padding:32px 0;", "{padding:40px 0;}", "{padding:48px 0;}", "{padding:64px 0;}"], _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop'));
var StyledSectionHeader = styled_components_1.default(atoms_1.SectionHeader).withConfig({
    displayName: "ImageAndCopyGrid__StyledSectionHeader",
    componentId: "sc-1us59xh-1"
})(["padding-top:0 !important;"]); // Grid
var Grid = styled_components_1.default(atoms_1.Margin).withConfig({
    displayName: "ImageAndCopyGrid__Grid",
    componentId: "sc-1us59xh-2"
})(["display:grid;grid-row-gap:32px;grid-column-gap:16px;grid-template-columns:repeat(auto-fill,minmax(272px,1fr));", "{grid-row-gap:40px;grid-column-gap:24px;}", "{grid-row-gap:48px;grid-column-gap:32px;}", "{grid-row-gap:64px;grid-column-gap:40px;}"], _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop')); // Item (a.k.a. "Pillar")
var Item = styled_components_1.default.div.withConfig({
    displayName: "ImageAndCopyGrid__Item",
    componentId: "sc-1us59xh-3"
})([""]);
var ImageWrapper = styled_components_1.default.div.withConfig({
    displayName: "ImageAndCopyGrid__ImageWrapper",
    componentId: "sc-1us59xh-4"
})(["position:relative;width:100%;"]);
var StyledImage = styled_components_1.default(function (props) {
    return /*#__PURE__*/ react_1.default.createElement(atoms_1.Image, props);
}).withConfig({
    displayName: "ImageAndCopyGrid__StyledImage",
    componentId: "sc-1us59xh-5"
})(["display:block;max-width:100%;height:auto;object-fit:cover;", " ", " ", "{", "}", "{", "}", "{", "}"], function (props) {
    return props.frame === 'circle' && "\n    border-radius: 100%;\n  ";
}, function (props) {
    return props.frame === 'arch' && "\n    border-radius: 184px 184px 0 0;\n  ";
}, _utils_1.mediaQuery('tablet'), function (props) {
    return props.frame === 'arch' && "\n      border-radius: 166px 166px 0 0;\n    ";
}, _utils_1.mediaQuery('laptop'), function (props) {
    return props.frame === 'arch' && "\n      border-radius: 150px 150px 0 0;\n    ";
}, _utils_1.mediaQuery('desktop'), function (props) {
    return props.frame === 'arch' && "\n      border-radius: 180px 180px 0 0;\n    ";
});
var BoxShadow = styled_components_1.default.div.withConfig({
    displayName: "ImageAndCopyGrid__BoxShadow",
    componentId: "sc-1us59xh-6"
})(["z-index:-1;position:absolute;bottom:2%;left:0;width:100%;height:96%;box-shadow:0 24px 32px ", ";", " ", " ", "{", "}", " ", "{", "}"], _utils_1.rgba(_theme_1.palette.black, 0.08), function (props) {
    return props.frame === 'circle' && "\n    border-radius: 100%;\n  ";
}, function (props) {
    return props.frame === 'arch' && "\n    border-radius: 184px 184px 0 0;\n    height: 90%;\n  ";
}, _utils_1.mediaQuery('tablet'), function (props) {
    return props.frame === 'arch' && "\n      border-radius: 166px 166px 0 0;\n    ";
}, function (props) {
    return props.frame === 'arch' && "\n    border-radius: 150px 150px 0 0;\n  ";
}, _utils_1.mediaQuery('desktop'), function (props) {
    return props.frame === 'arch' && "\n      border-radius: 180px 180px 0 0;\n    ";
});
var Copy = styled_components_1.default.div.withConfig({
    displayName: "ImageAndCopyGrid__Copy",
    componentId: "sc-1us59xh-7"
})(["padding-top:32px;", "{padding:32px 8px 0;}", "{padding:40px 8px 0;}", "{padding:48px 16px 0;}"], _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop'));
var Title = styled_components_1.default.h3.withConfig({
    displayName: "ImageAndCopyGrid__Title",
    componentId: "sc-1us59xh-8"
})(["position:relative;", " color:", ";&::after,&::before{display:block;height:0;width:0;content:'';}&::before{margin-top:calc((1 - 1.15) * 1em);}&::after{margin-top:calc((1 - 1.4) * 1em);}"], _theme_1.type.h3, _theme_1.palette.black);
var Caption = styled_components_1.default.div.withConfig({
    displayName: "ImageAndCopyGrid__Caption",
    componentId: "sc-1us59xh-9"
})(["padding-top:24px;", " & p{padding-top:24px;&::before,&::after{display:block;height:0;width:0;content:'';}&::before{margin-top:calc((1 - 1.3) * 1em);}&::after{margin-top:calc((1 - 1.5) * 1em);}}& p:first-of-type{padding-top:0 !important;}", "{", "}", "{padding-top:32px;& p{padding-top:32px;}}"], _theme_1.type.p, _utils_1.mediaQuery('tablet'), _theme_1.type.pSmall, _utils_1.mediaQuery('desktop')); // Typing
exports.default = ImageAndCopyGrid;
